module.exports = __webpack_public_path__ + "ddf4c5438454cd6e87cade3a66faa9c8.ttf";